/**
 * @fileoverview Local form state and change handlers for one additional contact.
 */

import { useEffect, useState } from "react";

const syncAdditionalContactLocalState = (contact, set) => {
  set.selectedTitle(contact.titulo !== undefined ? contact.titulo : null);
  set.birthDate(
    contact.fechaNacimiento !== undefined ? contact.fechaNacimiento : "",
  );
  set.selectedGender(contact.genero !== undefined ? contact.genero : null);
  set.selectedArea(contact.area !== undefined ? contact.area : null);
  set.selectedCountryCode(contact.telefonoCodigoPais || null);
  set.selectedCellphoneCountryCode(contact.celularCodigoPais || null);
  set.showPhone(
    contact.mostrarTelefono !== undefined ? contact.mostrarTelefono : false,
  );
  set.showCellphone(
    contact.mostrarCelular !== undefined ? contact.mostrarCelular : false,
  );
  set.showExtension(
    contact.mostrarExtension !== undefined ? contact.mostrarExtension : false,
  );
  set.showMainEmailAddress(
    contact.mostrarCorreoElectronico !== undefined
      ? contact.mostrarCorreoElectronico
      : false,
  );
  set.showBirthDate(
    contact.mostrarFechaNacimiento !== undefined
      ? contact.mostrarFechaNacimiento
      : false,
  );
  set.showGender(
    contact.mostrarGenero !== undefined ? contact.mostrarGenero : false,
  );
  set.showArea(contact.mostrarArea !== undefined ? contact.mostrarArea : false);
};

export const useAdditionalContactForm = ({
  contact,
  index,
  onContactChange,
}) => {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkTablet = () => {
      setIsTablet(window.innerWidth >= 768 && window.innerWidth <= 1023);
    };

    checkTablet();
    window.addEventListener("resize", checkTablet);

    return () => window.removeEventListener("resize", checkTablet);
  }, []);

  const [selectedTitle, setSelectedTitle] = useState(contact?.titulo || null);
  const [birthDate, setBirthDate] = useState(contact?.fechaNacimiento || "");
  const [selectedGender, setSelectedGender] = useState(contact?.genero || null);
  const [selectedArea, setSelectedArea] = useState(contact?.area || null);
  const [selectedCountryCode, setSelectedCountryCode] = useState(
    contact?.telefonoCodigoPais || null,
  );
  const [selectedCellphoneCountryCode, setSelectedCellphoneCountryCode] =
    useState(contact?.celularCodigoPais || null);
  const [showPhone, setShowPhone] = useState(
    contact?.mostrarTelefono !== undefined ? contact.mostrarTelefono : false,
  );
  const [showCellphone, setShowCellphone] = useState(
    contact?.mostrarCelular !== undefined ? contact.mostrarCelular : false,
  );
  const [showExtension, setShowExtension] = useState(
    contact?.mostrarExtension !== undefined ? contact.mostrarExtension : false,
  );
  const [showMainEmailAddress, setShowMainEmailAddress] = useState(
    contact?.mostrarCorreoElectronico !== undefined
      ? contact.mostrarCorreoElectronico
      : false,
  );
  const [showBirthDate, setShowBirthDate] = useState(
    contact?.mostrarFechaNacimiento !== undefined
      ? contact.mostrarFechaNacimiento
      : false,
  );
  const [showGender, setShowGender] = useState(
    contact?.mostrarGenero !== undefined ? contact.mostrarGenero : false,
  );
  const [showArea, setShowArea] = useState(
    contact?.mostrarArea !== undefined ? contact.mostrarArea : false,
  );

  // Update local state when contact prop changes
  useEffect(() => {
    if (contact) {
      syncAdditionalContactLocalState(contact, {
        selectedTitle: setSelectedTitle,
        birthDate: setBirthDate,
        selectedGender: setSelectedGender,
        selectedArea: setSelectedArea,
        selectedCountryCode: setSelectedCountryCode,
        selectedCellphoneCountryCode: setSelectedCellphoneCountryCode,
        showPhone: setShowPhone,
        showCellphone: setShowCellphone,
        showExtension: setShowExtension,
        showMainEmailAddress: setShowMainEmailAddress,
        showBirthDate: setShowBirthDate,
        showGender: setShowGender,
        showArea: setShowArea,
      });
    }
  }, [contact]);

  const handleInputChange = (field, value) => {
    if (onContactChange) {
      onContactChange(index, field, value);
    }
  };

  const handleToggleChange = (field, value) => {
    if (onContactChange) {
      onContactChange(index, field, value);
    }
  };

  return {
    isTablet,
    selectedTitle,
    setSelectedTitle,
    birthDate,
    setBirthDate,
    selectedGender,
    setSelectedGender,
    selectedArea,
    setSelectedArea,
    selectedCountryCode,
    setSelectedCountryCode,
    selectedCellphoneCountryCode,
    setSelectedCellphoneCountryCode,
    showPhone,
    setShowPhone,
    showCellphone,
    setShowCellphone,
    showExtension,
    setShowExtension,
    showMainEmailAddress,
    setShowMainEmailAddress,
    showBirthDate,
    setShowBirthDate,
    showGender,
    setShowGender,
    showArea,
    setShowArea,
    handleInputChange,
    handleToggleChange,
  };
};
